import { graphql } from "@/graphql/codegen"

graphql(`
  fragment SalesOrderLineProductFields on Product {
    productId
    publicId
    externalSystemId
    companyProductDescription
    vendorDescription
    computedProductStatus
    stockType
  }
`)

graphql(`
  fragment SalesOrderLineFields on CustomerPurchaseOrderProductLine {
    id
    uomId
    deliverDate
    pallets
    units
    quantityInUom
    pricePerUom
    priceUomId
    isManualPriceSet
    customerPurchaseOrder {
      cpoNumber
    }
    product {
      ...SalesOrderLineProductFields
    }
  }
`)

graphql(`
  fragment CustomerOrderSalesOrderFields on SalesOrder {
    salesOrderId
    publicId
    status
    deliveryDate
    ladingBill
    confirmationSentOn
    promisedShipOn
    requestedShipOn
    isRequestedShipAsap
    isDeliveryDateAsap
    warehouseShippedOn
    incoterms
    incotermsLocationId
    incotermsLocation {
      ...LocationBaseFields
    }
    shipViaCompanyId
    shipViaCompany {
      ...CompanyBaseFields
    }
    freightTerms
    freightCost
    freightQuantity
    freightQuoteNumber
    trackingNumber
    shipmentStatus
    bolNotes
    pickTicketNotes
    totalPallets
    totalAmount
    cpoNumbers
    shipFromWarehouseArea {
      ...WarehouseAreaBaseFields
      location {
        ...LocationBaseFields
      }
    }
    lines {
      ...SalesOrderLineFields
    }
  }
`)
